import { AxiosResponse } from 'axios';

import api from '~/services/api';
import { DailyReportData } from './vendor-client-visit-interface';
import { UserInterface } from '@e3labs/isa-data-dictionary';

class DailyReportServices {
  getListSuccessDailyReports(
    { skip = 0, limit = 10, ...rest },
    opts?: any
  ): Promise<AxiosResponse<DailyReportData[] | null>> {
    return api.get('/vendor-client-visit/daily/report-json', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getSuccessRowCount({ skip = 0, limit = 10, ...rest }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/daily/report-json?isCount=true', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getListFailedDailyReports(
    { skip = 0, limit = 10, ...rest },
    opts?: any
  ): Promise<AxiosResponse<DailyReportData[] | null>> {
    return api.get('/vendor-client-visit/daily/report-json', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getFailedRowCount({ skip = 0, limit = 10, ...rest }, opts?: any): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/daily/report-json?isCount=true', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getCSVSuccessDailyReports({ ...params }): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/daily/report-csv', {
      params: {
        ...params
      },
      headers: {
        'Content-Disposition': 'attachment; filename=report.csv',
        'Content-Type': 'text/csv'
      },
      responseType: 'arraybuffer'
    });
  }

  getXslxSuccessDailyReports({ ...params }): Promise<AxiosResponse<any[] | null>> {
    return api.get('/vendor-client-visit/daily/report-xlsx', {
      params: {
        ...params
      },
      headers: {
        'Content-Disposition': 'attachment; filename=report.xlsx',
        'Content-Type': 'application/vnd.ms-excel'
      },
      responseType: 'arraybuffer'
    });
  }

  getSellers(opts?: any): Promise<AxiosResponse<UserInterface[] | null>> {
    return api.get('/user', {
      params: {},
      ...opts
    });
  }
}

export default new DailyReportServices();
